export default __webpack_public_path__ + "static/media/element_58.eec4bee5.jpg";